import { ROLE } from "../utils/commonConstant";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";

export const FetchDocumentData = async (clientId, role) => {
  if (role === ROLE.ADMIN) {
    try {
      const response = await fetchFromWebApi(
        `HHDocument/GetHHDocumentsListByClientId?clientId=${clientId}`,
        {
          method: "GET"
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  } else {
    try {
      const response = await fetchFromWebApi(
        `HHDocument/GetApprovalRequiredHHDocumentsList?clientId=${clientId}`,
        {
          method: "GET"
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      return result;
    } catch (err) {
      throw new Error(err.message);
    }
  }
};

export const CreateDocument = async (document) => {
  try {
    const res = await fetchFromWebApi(
      `HHDocument/Create`,
      {
        method: "POST",
        body: JSON.stringify(document)
      }
    );
    return res;
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};
export const UpdateDocument = async (document) => {
  try {
    const res = await fetchFromWebApi(
      `HHDocument/Update`,
      {
        method: "PUT",
        body: JSON.stringify(document)
      }
    );
    return res;
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};
